export var NotificationPlatform;
(function (NotificationPlatform) {
    /**Apple*/
    NotificationPlatform["APNS"] = "APNS";
    /**Apple sandbox*/
    NotificationPlatform["APNS_VOIP_SANDBOX"] = "APNS_VOIP_SANDBOX";
    /**Apple VOIP sandbox*/
    NotificationPlatform["APNS_SANDBOX"] = "APNS_SANDBOX";
    /**Google Cloud Messaging*/
    NotificationPlatform["GCM"] = "GCM";
})(NotificationPlatform || (NotificationPlatform = {}));
//# sourceMappingURL=NotifTypes.js.map